import React from 'react'
import styled from 'styled-components'
const ChoiceFillingInstruction = ({ action, onChange }) => {

  return (
    <CSS>
      <center className='counsellingCss' >
        {
          action == 'Not Started' &&

          <>
            <p style={{ textAlign: 'center', color: 'red', fontWeight: '600', marginTop: '7rem' }}>College Choice Filling Round 1  will begin from 10th July, 2025, 12:00 PM</p>
            <center><button className='counsellingButton'
              onClick={() => { alert('College Choice Filling Round 1  will begin from 10th July, 2025, 12:00 PM') }}

            >College Choice Filling Round 1 (Click here)</button></center>

          </>
        }
        {/* {
                    action == 'Started' &&

                    <>
                        <p style={{ textAlign: 'center', color: 'red', fontWeight: '600', marginTop: '10rem', fontSize: '20px' }}>Time Over for College Choice Filling Round 1 </p>
                    </>
                } */}
        {
          action == 'Started' &&
          <>
            <div style={{ padding: '1rem' }}>
              <div
                style={{
                  backgroundColor: '#042e2e',
                  color: 'white',
                  textAlign: 'center',
                  padding: '0.75rem',
                  borderRadius: '8px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                }}
              >
                Important Instructions for Choice Filling Rounds
              </div>

              <ul style={{ marginTop: '1rem', paddingLeft: '1.5rem', fontSize: '1rem', lineHeight: '1.5rem' }}>
                <li>
                  Candidates are advised not to disclose or share their
                  <span style={{ color: 'red', fontWeight: '500' }}> login ID & password</span> with anybody. AICEE
                  will not be responsible for violation or misuse of the password of a candidate.
                </li>
                <li>Always save your college choices before logging out.</li>
                <li>
                  Do not click on <strong>"Final Submit"</strong> button until you want to lock all your filled
                  choices.
                </li>
                <li>
                  Students won't be able to modify or change their college choice after
                  <strong>"Final Submit"</strong>.
                </li>
                <li>
                  <span style={{ color: 'red', fontWeight: '600' }}>
                   Few Institutions will not be there in choice filling options whose seats are filled during round 1 of counseling.
                  </span>
                </li>
                <li>
                  <span style={{ color: 'red', fontWeight: '600' }}>
                    Last Date to submit College Choices for Round 3 is 26th July, 2025, 11:00 PM
                  </span>
                </li>
              </ul>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5rem' }}>
                <button
                  style={{
                    backgroundColor: '#042e2e',
                    color: 'white',
                    fontWeight: '600',
                    padding: '0.6rem 1.2rem',
                    borderRadius: '6px',
                    border: 'none',
                    fontSize: '1rem',
                    cursor: 'pointer',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    transition: 'background 0.3s',
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = '#042e2e')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = '#042e2e')}
                  // onClick={() => onChange('Choice Fill')}
                  //  onClick={() => { alert('College Choice filling Round 3 will begin from 25th July 2025 12:00 PM') }}
                   onClick={() => { alert('Time over for college choice filling roung 3') }}
                >
                  Proceed for College Choice Filling Round 3 (Click here)
                </button>
              </div>
            </div>

          </>
        }
      </center>

    </CSS>
  )
}


const CSS = styled.main`
.proceedButton{
  width: 80%;
    padding: 8px 15px;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    margin: auto;
    text-align: center;
}
.counsellingCss{
  /* border: 2px solid black; */
  /* width: 45%;
  margin: auto; */
  margin-top: 1rem;
  text-align: justify;
  /* justify-content: start; */
  /* justify-content: start; */
  /* margin: 2rem 20rem; */
}
.counsellingCss{
  /* margin-left: 11rem; */
  padding-top: 2rem;
  width: 60%;
  margin:auto
}
.counsellingCss>li{
  margin-left: 10%;
 
}
@media only screen and (max-width: 480px){
.counsellingCss{
  text-align: justify;
  border: 1px solid black;
}
li{
  text-align: justify;
  padding-left: 1rem;
  padding-right: 1rem;
}
  /* .counsellingCss>li{
  margin-left: 0rem;
} */
  .counsellingCss{
  /* border: 2px solid black; */
  /* margin: 1rem; */
  padding: 1rem;
  width: 100%;
  text-align: justify;
  /* justify-content: start; */
  /* margin: 2rem 20rem; */
}
.counsellingButton{
  border: 3px solid black;
  width: 80%;
  margin: auto;
}
.counsellingCss>li{
  margin-left: 0rem;
}
}
@media only screen and (max-width: 1280px){
  
  .counsellingCss{
  /* border: 2px solid black; */
  /* margin: 1rem; */
  padding: 1rem;
  width: 100%;
  margin: auto;
  text-align: justify;
  /* justify-content: start; */
  /* margin: 2rem 20rem; */
}
}

.counsellingButton{
  padding: 0.5rem 2rem;
  color: white;
  background-color: #042e2e;
}
.counsellingButton2{
  margin: 1rem;
  padding: 0.5rem 2rem;
  color: white;
  background-color: #042e2e;
  margin-top: 12rem;
}
`

export default ChoiceFillingInstruction